export default __webpack_public_path__ + "static/media/CormorantGaramondLightItalic.7d111cc4.woff";